<script>
    import {onMount} from 'svelte';
    import {scale} from 'svelte/transition';
    import {cubicInOut} from 'svelte/easing';

    import {Modal} from 'flowbite';

    let {
        isModalOpen = $bindable(false),
        id = 'ride-share-modal',
        children
    } = $props();

    let _modalElement;

    const _initializeModal = () => {
        if (_modalElement) {
            return;
        }

        const targetElement = document.getElementById(id);
        if (!targetElement) {
            return;
        }

        const modalOptions = {
            placement: 'center-center',
            backdrop: 'dynamic',
            backdropClasses: 'bg-gray-900/50 dark:bg-gray-900/80 fixed inset-0 z-modal-background',
            closable: true,
            // onShow: () => {
            // },
            onHide: () => {
                isModalOpen = false;
            }
        };

        _modalElement = new Modal(targetElement, modalOptions);
    };

    const _handleModalClose = () => {
        _modalElement.hide();
    };

    onMount(() => {
        _initializeModal();
    });

    $effect(() => {
        if (!_modalElement) {
            return;
        }

        if (isModalOpen) {
            _modalElement.show();
        } else {
            _modalElement.hide();
        }
    });
</script>

<div id={id}
     class="hidden fixed top-0 left-0 right-0 w-full h-[calc(100%-1rem)] max-h-full mt-3 p-1 md:p-4 overflow-x-hidden overflow-y-auto md:inset-0 z-modal"
     tabindex="-1">
    {#if isModalOpen}
        <div class="relative w-full md:w-2/3 lg:w-3/5 max-w-6xl max-h-full"
             transition:scale={{duration: 700, easing: cubicInOut}}>
            <div class="relative bg-white rounded-lg shadow-sm dark:bg-gray-700">
                {@render children({onCloseModal: _handleModalClose})}

                <button type="button"
                        class="absolute top-3 right-3 inline-flex justify-center items-center w-8 h-8 ms-auto text-sm text-gray-900 bg-transparent hover:bg-gray-200 rounded-lg cursor-pointer"
                        onclick={_handleModalClose}>
                    <svg class="w-4 h-4"
                         aria-hidden="true"
                         xmlns="http://www.w3.org/2000/svg"
                         fill="none"
                         viewBox="0 0 14 14">
                        <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                              d="m1 1 6 6m0 0 6 6M7 7l6-6M7 7l-6 6"/>
                    </svg>
                    <span class="sr-only">Close modal</span>
                </button>
            </div>
        </div>
    {/if}
</div>
